import { useState } from "react";
import { useCfmContext } from "../../Context/CfmContext";
import CashLumpSum from "./HelperFunctions/CashLumpSum";
import AdHoc from "./HelperFunctions/AdHoc";
import PotentialDropRisk from "./HelperFunctions/PotentialDropRisk";
import "../../../../../css/CashflowModeller2/Tabs/CfmTabs.css"; // Import your CSS file
import Notes from "./HelperFunctions/Notes";

const TABS = ["Notes", "Tax Free Cash", "Ad hoc"];
// , "Potential Drop Risk"

/**
 * CfmTabs is a React functional component that renders a tabbed interface for the Cashflow Modeller tool.
 * It manages the active tab state locally and displays the corresponding content for each tab.
 * The component interacts with a global context to dispatch updates as needed.
 *
 * Tabs available:
 * - "Tax Free Cash": Displays the CashLumpSum component.
 * - "Ad hoc": Displays the AdHoc component.
 * - "Potential Drop Risk": Displays the PotentialDropRisk component.
 * - "Notes": Displays the Notes component.
 *
 * @component
 * @returns {JSX.Element} The rendered tabbed interface with dynamic content based on the selected tab.
 */
const CfmTabs = () => {
  // Access global state and dispatch from context
  const { state, dispatch } = useCfmContext();
  // Local state to track the currently active tab
  const [activeTab, setActiveTab] = useState("Notes");

  /**
   * Dispatches updates to the context state.
   * @param {string} type - The action type.
   * @param {any} newData - The payload for the action.
   */
  const handleUpdate = (type, newData) => {
    dispatch({ type, payload: newData });
  };

  /**
   * Renders the content for the currently active tab.
   * @returns {JSX.Element|null}
   */
  const renderTabContent = () => {
    switch (activeTab) {
      case "Tax Free Cash":
        // Show the CashLumpSum component for "Tax Free Cash" tab
        return <CashLumpSum />;
      case "Ad hoc":
        // Show the AdHoc component for "Ad hoc" tab
        return <AdHoc />;
      case "Potential Drop Risk":
        // Show the PotentialDropRisk component for "Potential Drop Risk" tab
        return <PotentialDropRisk />;
      case "Notes":
        // Show the Notes component for "Notes" tab
        return <Notes />;
      default:
        // Fallback: render nothing if tab is unrecognized
        return null;
    }
  };

  return (
    <div className="tabs-container">
      {/* Tab buttons for switching between tabs */}
      <div className="tab-buttons">
        {TABS.map((tab) => (
          <div
            key={tab}
            className={`tab-button ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            <div className="Title">{tab}</div>
          </div>
        ))}
      </div>
      {/* Content area for the selected tab */}
      <div className="tab-content">{renderTabContent()}</div>
    </div>
  );
};

export default CfmTabs;

